var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.userInfoOrder
        ? _c(
            "div",
            { staticClass: "flex-between", staticStyle: { width: "100%" } },
            [
              _c(
                "div",
                {
                  staticClass: "margin-left-10",
                  staticStyle: { width: "60%" },
                },
                [
                  _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.handleClick },
                      model: {
                        value: _vm.active,
                        callback: function ($$v) {
                          _vm.active = $$v
                        },
                        expression: "active",
                      },
                    },
                    _vm._l(_vm.tab, function (item) {
                      return _c("el-tab-pane", {
                        key: item.state,
                        attrs: {
                          label: item.stateStr + " (" + item.nums + ")",
                          value: item.state,
                          name: item.state,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { staticStyle: { width: "30%" }, attrs: { column: "1" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "订单消费金额" } },
                    [
                      _vm._v(
                        _vm._s(_vm.userInfoOrder.payAmount) +
                          "元（计算订单剩余金额）"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.records,
            border: "",
            size: "mini",
            "element-loading-text": "正在加载中～",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "订单编号",
              prop: "orderNo",
              align: "center",
              width: "220",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "color-mainColor",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.orderNo))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "线路", prop: "lineName", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "出发时间",
              prop: "departureDateTime",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "实际人数",
              prop: "passengerNums",
              align: "center",
              width: "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "支付金额(元)",
              prop: "payAmount",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "订单评价", prop: "indicator", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.indicator || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "订单状态",
              prop: "stateStr",
              align: "center",
              width: "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "开票状态",
              prop: "invoiceStateStr",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.invoiceStateStr))]),
                    scope.row.invoiceState === 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "font-12 margin-left-10",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.getUserInvoiceUrl(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("查看发票")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "right",
            "margin-right": "20px",
            "margin-top": "20px",
          },
        },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.paginationObj.current,
              "page-size": _vm.paginationObj.size,
              background: "",
              layout: "prev, pager, next",
              total: _vm.total,
              size: "mini",
            },
            on: { "current-change": _vm.handleCurrentChange },
          }),
        ],
        1
      ),
      _vm.showVisible
        ? _c("intercity-info", { ref: "interCityInfo" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }